/**
 * A screen's parts listed down the left, with the part chosen shown beside it.
 *
 * One drawing for every such list, Settings' and a screen's own, so they cannot come
 * to look different: sections ruled off under their own headings, the entries of each
 * hanging from a guide line, the one showing marked in teal, as the Help index is
 * drawn. Labels only, with each entry's line of detail on hover.
 */

export interface SideNavEntry {
  key: string
  label: string
  /** The entry's line of detail, on hover. */
  blurb?: string
  showing: boolean
  select: () => void
}

export interface SideNavSection {
  title: string
  /** The section's line of detail, on hover. */
  hint?: string
  entries: SideNavEntry[]
}

export function SideNav({ label, sections }: { label: string; sections: SideNavSection[] }) {
  return (
    <nav className="help-index settings-nav" aria-label={label}>
      {sections.map((group) => (
        <div
          key={group.title}
          className={['help-group', 'open', group.entries.some((e) => e.showing) && 'current']
            .filter(Boolean)
            .join(' ')}
        >
          <div className="help-group-head" title={group.hint}>
            <span className="help-group-title">{group.title}</span>
            <span className="help-group-count">{group.entries.length}</span>
          </div>
          <div className="help-group-items">
            {group.entries.map((entry) => (
              <button
                key={entry.key}
                type="button"
                className="help-index-item"
                title={entry.blurb || undefined}
                aria-current={entry.showing ? 'page' : undefined}
                onClick={entry.select}
              >
                {entry.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </nav>
  )
}
